module.exports = __webpack_public_path__ + "img/bj1.c62935d8.png";